//Functionality shared between /home/Calendar, /admin/Calendar, /home/CalendarList, /admin/CalendarList

var legendTemplate;
var hasActionPermissions;
var onlyShowActivitiesWithOpenRegistration = false; //param that does not have a corresponding control
var isMultiTier = false;

//#region Public & Volunteer Calendar
if (typeof (getSelectedTiers) !== 'function') {
    getSelectedTiers = function () {
        return null;
    }
}

if (typeof (getSelectedDepartments) !== 'function') {
    getSelectedDepartments = function () {
        return getCommaSepString('#departmentFilter');
    }
}

if (typeof (getSelectedGeographicAreas) !== 'function') {
    getSelectedGeographicAreas = function () {
        return null;
    }
}

if (typeof (getSelectedPlaces) !== 'function') {
    getSelectedPlaces = function () {
        return getCommaSepString('#placeFilter');
    }
}
//#endregion Public & Volunteer Calendar

$(function () {
    initValidation();
    initSharedHandlebars();

    $('.select2').select2();

    if (isAdminCalendar) {
        $(document).on('click', '#setDefaultFilters', function () {
            var data = getDataFromFilterControls(null, null, true);
            setDefaultListPageFilters($(this), data);
        });

        initTierDepartmentPicker();
        initGeographicAreaPlaceFilter();
    }

    var parsedUrl = $.url.parse(document.URL);

    initDepartment(parsedUrl);

    loadCalendarDepartmentFilters(getSelectedDepartments(),
        function () {
            initEvents();
            initFilters(parsedUrl);
            initResultsView();
        });

    hasActionPermissions = $('#newActivityBtn').length > 0 || $('#newSiteVisitBtn').length > 0;

    if (isAdminCalendar && hasActionPermissions) {
        initNewActivityModal();
    }

    $('#onlyShowActivitiesWithOpenAssignments').change(function () {
        var checked = $(this).is(':checked');

        if (checked) {
            $('#onlyShowRegisteredActivities').attr('disabled', true);
            $('#onlyShowRegisteredActivities').parent().addClass('disabled');

            $('#onlyShowVolunteerSchedule').attr('disabled', true);
            $('#onlyShowVolunteerSchedule').parent().addClass('disabled');
        } else {
            $('#onlyShowRegisteredActivities').removeAttr('disabled');
            $('#onlyShowRegisteredActivities').parent().removeClass('disabled');

            $('#onlyShowVolunteerSchedule').removeAttr('disabled');
            $('#onlyShowVolunteerSchedule').parent().removeClass('disabled');
        }
    });
});

function initNewActivityModal() {
    $('#newActivityForm #Place').select2();

    if ($('#newActivityForm #Department').hasClass('select2')) {
        $('#newActivityForm #Department').select2();
    }

    if (isMultiDepartment) {
        $('#newActivityEdit').on('change', '#Department', function () {
            var departmentId = $(this).val();

            if (!$('#newActivityEdit #Place').val() && departmentId) {
                $.get('/api/Admin/DefaultDepartmentPlace/' + departmentId, function (placeId) {
                    if (placeId) {
                        $('#newActivityEdit #Place').val(placeId).trigger('change');
                    }
                });
            }
        });
    }

    $('#newActivityEdit').on("shown.bs.modal", function () {
        $('#newEventDropdown').hide();

        $('#newActivityForm #Title').focus();
    });

    $('#newActivityEdit').on("hidden.bs.modal", function () {
        $('#newActivityForm #Title').val('');
        $('#newActivityForm #StartDate').val('');
        $('#newActivityForm #Place').val('').trigger('change');

        if (isMultiDepartment) {
          $('#newActivityForm #Department').val('').trigger('change');
        }

        $("#newActivityForm").validate().resetForm();
    });

    $('#newActivityForm').validate(extendValidationSettings({
        rules: {
            Title: {
                required: true,
                minlength: 2,
                maxlength: 100
            },
            StartDate: {
                required: true,
                date: true
            },
            Department: {
                required: '#Department.select2'
            }
        },
        messages: {
            Title: {
                required: 'Title is required.',
                minlength: jQuery.validator.format('Title must be at least {0} characters.'),
                maxlength: jQuery.validator.format('Title must be less than {0} characters.')
            },
            StartDate: {
                required: 'Start Date is required.',
                date: 'Start Date must be a valid date.'
            },
            Department: {
                required: 'Department is required.'
            }
        },
        errorContainer: '#newActivityErrorMessageBox',
        errorLabelContainer: '#newActivityErrorList'
    }));
}

function initSharedHandlebars() {
    Handlebars.registerHelper('ifNotNull', function (exp, options) {
        if (exp) {
            return options.fn(this);
        }
        return options.inverse(this);
    });

    legendTemplate = Handlebars.compile($("#legendTemplate").html());
}

function getDataFromFilterControls(start, end, removeDefaults) {
    var data = {
        start: getStartDate(start),
        end: getEndDate(end),
        tiers: getSelectedTiers(),
        departments: getSelectedDepartments(),
        geographicAreas: getSelectedGeographicAreas(),
        places: getSelectedPlaces(),
        volunteerCategories: getCommaSepString('#volunteerCategoryFilter'),
        activityCategories: getCommaSepString('#categoryFilter'),
        ageGroups: getCommaSepString('#ageGroupFilter'),
        siteVisitTypes: getCommaSepString('#siteVisitTypeFilter'),
        interests: getCommaSepString('#interestFilter'),
        showSiteVisits: ($('#showSiteVisits').length) ? $('#showSiteVisits').is(':checked') : false,
        showActivities: ($('#showActivities').length) ? showFalse($($('#showActivities')[0]).is(':checked')) : true,
        showShifts: ($('#showShifts').length) ? $('#showShifts').is(':checked') : false,
        onlyShowActivitiesWithOpenRegistration: onlyShowActivitiesWithOpenRegistration,
        onlyShowActivitiesWithOpenAssignments: $('#onlyShowActivitiesWithOpenAssignments').is(':checked'),
        onlyShowActivitiesWithNoAssignments: ($('#onlyShowActivitiesWithNOAssignments').length) ? $('#onlyShowActivitiesWithNOAssignments').is(':checked') : false,
        onlyShowShiftsWithOpenSlots: ($('#onlyShowShiftsWithOpenSlots').length) ? $('#onlyShowShiftsWithOpenSlots').is(':checked') : false,
        onlyShowRegisteredActivities: !$('#onlyShowActivitiesWithOpenAssignments').is(':checked') && $('#onlyShowRegisteredActivities').length ? $('#onlyShowRegisteredActivities').is(':checked') : false,
        onlyShowVolunteerSchedule: !$('#onlyShowActivitiesWithOpenAssignments').is(':checked') && $('#onlyShowVolunteerSchedule').length ? $('#onlyShowVolunteerSchedule').is(':checked') : false,
        isAdminCalendar: isAdminCalendar
    };

    if (removeDefaults) {
        delete data.isAdminCalendar;
        delete data.start;
        delete data.end;

        if (data.showActivities === true) {
            delete data.showActivities;
        }
    }

    return data;
}

//changes false boolean to string so it will not be filtered out by $.param()
function showFalse(value) {
    if (value === false) {
        return value.toString();
    }
    else {
        return value;
    }
}

function initDepartment(parsedUrl) {
    if (isAdminCalendar) {
        isMultiDepartment = $('#tierDepartments > option').length > 1;
    }
    else {
        isMultiDepartment = $('#departmentFilter > option').length > 1;
    }

    //departments/places are pre-populated by view-component for admin calendar
    if (!isAdminCalendar && parsedUrl.params) {
        if (parsedUrl.params.departments) {
            $('#departmentFilter').val(parsedUrl.params.departments.split(',')).trigger('change');
        }

        if (parsedUrl.params.places) {
            $('#placeFilter').val(parsedUrl.params.places.split(',')).trigger('change');
        }
    }
}

function initFilters(parsedUrl) {
    if (parsedUrl.params) {
        if (parsedUrl.params.start) {
            $('#startDateFilter').val(moment(parsedUrl.params.start).format('MM/DD/YYYY'));

            $('#endDateFilter').val(moment(parsedUrl.params.start).add(2, 'months').format('MM/DD/YYYY'));
        }

        if (parsedUrl.params.end) {
            $('#endDateFilter').val(moment(parsedUrl.params.end).format('MM/DD/YYYY'));
        }

        if (parsedUrl.params.volunteerCategories) {
            $('#volunteerCategoryFilter').val(parsedUrl.params.volunteerCategories.split(',')).trigger('change');
        }

        if (parsedUrl.params.activityCategories) {
            $('#categoryFilter').val(parsedUrl.params.activityCategories.split(',')).trigger('change');
        }

        if (parsedUrl.params.interests) {
            $('#interestFilter').val(parsedUrl.params.interests.split(',')).trigger('change');
        }

        if (parsedUrl.params.ageGroups) {
            $('#ageGroupFilter').val(parsedUrl.params.ageGroups.split(',')).trigger('change');
        }

        if (parsedUrl.params.siteVisitTypes) {
            $('#siteVisitTypeFilter').val(parsedUrl.params.siteVisitTypes.split(',')).trigger('change');
        }

        if (parsedUrl.params) {
            if (parsedUrl.params.showActivities === undefined) {
                parsedUrl.params.showActivities = true;
            }

            $('#showActivities').prop('checked', stringToBool(parsedUrl.params.showActivities));
            $('#showSiteVisits').prop('checked', stringToBool(parsedUrl.params.showSiteVisits));
            $('#showShifts').prop('checked', stringToBool(parsedUrl.params.showShifts));
            onlyShowActivitiesWithOpenRegistration = stringToBool(parsedUrl.params.onlyShowActivitiesWithOpenRegistration);
            $('#onlyShowActivitiesWithOpenAssignments').prop('checked', stringToBool(parsedUrl.params.onlyShowActivitiesWithOpenAssignments));
            $('#onlyShowActivitiesWithNOAssignments').prop('checked', stringToBool(parsedUrl.params.onlyShowActivitiesWithNoAssignments));
            $('#onlyShowShiftsWithOpenSlots').prop('checked', stringToBool(parsedUrl.params.onlyShowShiftsWithOpenSlots));
            $('#onlyShowRegisteredActivities').prop('checked', stringToBool(parsedUrl.params.onlyShowRegisteredActivities));
            $('#onlyShowVolunteerSchedule').prop('checked', stringToBool(parsedUrl.params.onlyShowVolunteerSchedule));

            $('.btn input[type="checkbox"]').each(function () {
                $this = $(this);
                if ($this.is(':checked')) {
                    $this.parents('.btn').addClass('active');
                }
                else {
                    $this.parents('.btn').removeClass('active');
                }
            });
        }
    }
}

function initValidation() {
    $('#filterForm').validate(extendValidationSettings({
        rules: {
            startDateFilter: {
                date: true
            },
            endDateFilter: {
                date: true,
                greaterThanOrEqual: '#startDateFilter'
            }
        },
        messages: {
            startDateFilter: {
                date: 'Start Date must be a valid date.'
            },
            endDateFilter: {
                date: 'End Date must be a valid date.',
                greaterThanOrEqual: 'End Date must be greater than or equal to Start Date.'
            }
        }
    }));
}

function initEvents() {
    $('#clearAdvancedFilters').click(clearAdvancedFilters);
    $('#applyAdvancedFilters').click(applyAdvancedFilters);

    if (isMultiDepartment) {
        if (isAdminCalendar) {
            $(document).on("departmentsChanged availableDepartmentsChanged", function (e) {
                loadCalendarDepartmentFilters(e.departments.join());
            });
        }
        else {
            $(document).on("change", '#departmentFilter', function (e) {
                loadCalendarDepartmentFilters(getSelectedDepartments());
            });
        }
    }
}

function clearAdvancedFilters() {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
        window.location = uri.substring(0, uri.indexOf("?")) + "?clear=true";
    }
    else {
        window.location = uri + "?clear=true";
    }
}

function loadCalendarDepartmentFilters(departmentIds, done) {
    var url = $.url.build({
        path: '/api/Home/CalendarDepartmentFilters',
        params: {
            departmentIds: departmentIds,
            isAdminCalendar: isAdminCalendar
        }
    });

    $.getJSON(url, function (data) {
        var selectedCategories = $('#categoryFilter').val();
        var selectedSiteVisitTypes = $('#siteVisitTypeFilter').val();

        $('#categoryFilter').empty().select2({ data: data.ActivityCategories }).trigger('change');
        $('#siteVisitTypeFilter').empty().select2({ data: data.SiteVisitTypes }).trigger('change');

        $('#categoryFilter').val(selectedCategories).trigger('change');
        $('#siteVisitTypeFilter').val(selectedSiteVisitTypes).trigger('change');

        if (done) {
            done();
        }
    });
}

function hasQueryParams(data) {
    return !(
        !(isMultiDepartment && data.departments)
        && !data.tiers
        && $("#startDateFilter").val() === defaultStartDate
        && !data.endDate
        && !data.volunteerCategories
        && !data.geographicAreas
        && !data.activityCategories
        && !data.places
        && !data.interests
        && !data.ageGroups
        && !data.siteVisitTypes
        && !data.showSiteVisits
        && !data.showShifts
        && !data.showActivities === false
        && !data.onlyShowShiftsWithOpenSlots
        && !data.onlyShowRegisteredActivities
        && !data.onlyShowVolunteerSchedule);
}
